import { render } from "./TaskActions.vue?vue&type=template&id=31062237&scoped=true&lang=pug"
import script from "./TaskActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskActions.vue?vue&type=script&setup=true&lang=js"

import "./TaskActions.vue?vue&type=style&index=0&id=31062237&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31062237"]])

export default __exports__